import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    inlineLayer: {
        pointerEvents: "box-none",
        position: "absolute",
        bottom: 0,
        start: 0,
        end: 0,
        top: 0
    }
});
export default stylesheet;
